import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";

const MostReadArticle = ({ mostReadArticles }) => {
    const { t } = useTranslation(["blog"]);
    const router = useRouter();
    const currentLang = router.asPath.includes('/blog/en') ? 'en' : 'tr';
    const isFullSlug = mostReadArticles.status !== 'records_not_found' ? mostReadArticles.some((article) => article?.slug?.startsWith('/blog/tr') || article?.slug?.startsWith('/blog/en')) : [];

    return (
        <div className="p-6">
            <h5 className="text-xl font-semibold">
                {t("blog:mostReadArticle")}
            </h5>

            {mostReadArticles && mostReadArticles.length > 0 ? (
                mostReadArticles.map((article, index) => (
                    <Link
                        href={isFullSlug ? `${article?.category_slug}/${article?.connection_id}/${article?.slug}` : `/blog/${currentLang}/${article?.category_slug}/${article?.connection_id}/${article?.slug}`}
                        // href={`blog/${article?.slug}`} 
                        key={index}
                    >
                        <div className={`flex items-center p-3 space-x-3 cursor-pointer ${index !== mostReadArticles.length - 1 ? "border-b-2 border-buttonBg" : ""}`}>
                            <p className="flex items-center justify-center w-6 h-6 p-4 text-black rounded-full bg-makdosYellow">
                                {index + 1}
                            </p>
                            <p className="font-medium text-textGray">
                                {article?.title}
                            </p>
                        </div>
                    </Link>
                ))
            ) : (
                <div className="py-4 text-center text-gray-500">
                    <p>{t("blog:noMostReadArticles", "En çok okunan makale bulunamadı.")}</p>
                </div>
            )}
        </div>
    )
}

export default MostReadArticle